import { createAction } from "redux-actions";

export const setLoading = createAction("SET_LOADING");
export const setLoaded = createAction("SET_LOADED");
export const setDirection = createAction("SET_DIRECTION");
export const setLanguage = createAction("SET_LANGUAGE");
export const setCurrency = createAction("SET_CURRENCY");
export const setWhiteLabel = createAction("SET_WL");
